import $ from 'jquery';
import SubscribeService from '../service/SubscribeService';
import Popup from '../util/Popup';

$('body').on('submit', '.footer-form', (e) => {
    e.preventDefault();
    SubscribeService.subscribeByEmail(
        $('.footer-form__email').val(),
        // [1,2,3]
    ).then((response) => {
        const message = response.status === 'success'
            ? 'Thank you for subscribing! A confirmation email will be sent to you'
            : 'Failed to sign e-mail, maybe it is already in use';
        Popup.notify(message);
    });
});